import React from 'react';
import { string } from 'prop-types';
import { Button, Typography } from '@one-thd/sui-atomic-components';
import { Refrigerator } from '@one-thd/sui-icons';
import bespokeProductMapping from '../data/bespoke-product-mapping.json';

export const BespokeApplianceCTA = ({ itemId }) => {
  const href = bespokeProductMapping[itemId];

  if (!href) return null;

  return (
    <div
      className="sui-flex sui-flex-wrap sui-justify-between sui-bg-primary sui-gap-2"
      data-testid="bespoke-appliance-cta"
    >
      <div className="sui-grid sui-auto-cols-auto sui-gap-x-2">
        <span className="sui-row-span-2 sui-self-center sui-mt-0">
          <Refrigerator data-testid="bespoke-icon" size="large" />
        </span>
        <div className="sui-col-start-2 sui-truncate">
          <Typography variant="h4" truncate>Design Your Own Bespoke<sup className="sui-text-xs">TM</sup></Typography>
        </div>
        <div className="sui-col-start-2 sui-truncate">
          <Typography variant="body-base" truncate>More colors and configurations available</Typography>
        </div>
      </div>
      <div className="sui-grow sm:sui-grow-0 sui-self-center">
        <Button variant="secondary" href={href}>Customize</Button>
      </div>
    </div>
  );
};

BespokeApplianceCTA.propTypes = {
  itemId: string.isRequired
};

BespokeApplianceCTA.displayName = 'BespokeApplianceCTA';
